module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ch-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "list2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter01"
    }
  }, [_c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("1 ")]), _vm._v("Blood and Sand")])]), _vm._v(" "), _c('h2', {
    staticClass: "list2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter02"
    }
  }, [_c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("2 ")]), _vm._v("Murder of a Matador")])]), _vm._v(" "), _c('h2', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("3 ")]), _vm._v("Magic Valley")])]), _vm._v(" "), _c('h2', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("4 ")]), _vm._v("A Ring Round the Moon")])]), _vm._v(" "), _c('h2', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("5 ")]), _vm._v("Lotus-Eater")])]), _vm._v(" "), _c('h2', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("6 ")]), _vm._v("Dust of Mexico")])]), _vm._v(" "), _c('h2', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("7 ")]), _vm._v("The Broken Man")])]), _vm._v(" "), _c('h2', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("8 ")]), _vm._v("Sheriff")])]), _vm._v(" "), _c('h2', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp"
  }, [_vm._v("9 ")]), _vm._v("Death on the Left")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("10")]), _vm._v(" The Triumph of the Emotions")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("11")]), _vm._v(" A Cloud Like a Man’s Hand")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("12")]), _vm._v(" International Bridge")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("13")]), _vm._v(" Bar Sinister")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("14")]), _vm._v(" The Mark of the Beast")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("15")]), _vm._v(" Tonatiuh")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("16")]), _vm._v(" Coup de Grâce")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("17")]), _vm._v(" The Shadowless Hour")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("18")]), _vm._v(" The Moment of Truth")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("19")]), _vm._v(" Sun on Capricorn")])]), _vm._v(" "), _c('h2', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "foot-sp1"
  }, [_vm._v("20")]), _vm._v(" The Criminal and His Motive")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0